import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { environment } from "../../../environments/environment";
import { Subject } from 'rxjs/Subject';
import { Project  } from 'src/app/_models/project.model';
import { values } from 'lodash';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RiskManagementService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);

   }
  
   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }


  // Create RiskManagements
  createRiskManagements(user: Object): Observable<Object> {
    console.log("In createRiskManagements method, RiskManagements: ", user);
    return this.http.post(`${environment.apiUrl}/riskManagements`, user).pipe(catchError(this.handleError));
  }
 
   // Get RiskManagements by Id Get
   getRiskManagements(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/riskManagements/${id}`).pipe(catchError(this.handleError));
  }

    //Delete riskManagements by Id Delete
  deleteRiskManagements(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/riskManagements/${id}`).pipe(catchError(this.handleError));
  }

   //Update riskManagements by Id Put
   updateRiskManagements(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/riskManagements/${id}`, user).pipe(catchError(this.handleError));
  }

     //Get All riskManagements by Id Get
     getAllRiskManagements(): Observable<Object> {
      return this.http.get(`${environment.apiUrl}/riskManagements`).pipe(catchError(this.handleError));
  }

  //Get Risk Management Option
  getAllRiskManagementOptions(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/riskManagementOptions`).pipe(catchError(this.handleError));
  }
  
}
